// Widget Scripts
import customTicketButton from './js/widgets/customTicketButton.js';
import slideshow from './js/widgets/slideshow.js';
import autoEvent from './js/widgets/autoEvent.js';
import cardWidget from './js/widgets/cardWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';
import photoGallery from './js/widgets/photoGallery.js';
import { aosAnimation } from './js/utils/helpers.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  customTicketButton();
  if (globalThis.location.pathname === '/') {
    slideshow();
    autoEvent();
    cardWidget();
    seoWidget('seoWidget', seoWidgetOpts, { showButton: true }, { seoMainHeading: true });
    photoGallery();
    scrollerSponsors();

    aosAnimation($('#siteInfoBannerWidget'), 'fade-up');
  }
});
